import Page from "../Common/Page";
import React from "react";
import { AuthContext } from "../Auth/Auth";
import {
  Button,
  Col,
  Form,
  message,
  Popconfirm,
  Row,
  Space,
  Spin,
  Modal,
  Checkbox,
} from "antd";
import { NavigateFunction } from "react-router-dom";
import {
  ExclamationCircleOutlined,
  FolderOpenOutlined,
  FolderOutlined,
} from "@ant-design/icons";
import { ApplyDocumentTabs } from "../Components/ApplyDocumentTabs";
import {
  ApplyDocumentDrawer,
  ApplyDocumentViewItem,
} from "../Components/ApplyDocumentDrawer";
import {
  SaveScoringDataItem,
  SaveScoringDataRequestBean,
  ScoringData,
  StartScoringResponseBean,
  SaveScoringResultResponseBean,
} from "./ScoringPage";
import { ScoringTable } from "./ScoringTable";
import { http } from "../Common/http";
import withRouterDom from "../Common/WithReactRouterDom";
import modal from "antd/lib/modal";
import { Messages } from "../Common/ValidateMessages";
import moment from "moment";
import { isNullOrSpace } from "../Common/Utils";

const { confirm } = Modal;

interface Props {
  objectId: string;
  useCase: string; // 1:採点担当者採点、2:採点確定、3:スーパー修正、4:閲覧
  scoringType: string; // 1：答案、2：面接
  scoringData: ScoringData;
  backToBeforePage: (needConfirm?: boolean) => void;
  setShowDialog: (showDialog: boolean) => void;
  navigation?: NavigateFunction;
}

class ScoringWrittenPage extends React.Component<Props, any> {
  static contextType = AuthContext;
  private _page: React.RefObject<Page>;
  private _form: React.RefObject<any>;

  constructor(props: Props, context) {
    super(props, context);
    this._page = React.createRef<Page>();
    this._form = React.createRef();

    // 欠席データをマップ化
    let afMap = new Map();
    if (this.props.useCase === "1") {
      afMap.set(
        this.props.scoringData.applicants[0].applicantId,
        this.props.scoringData.applicants[0].userScoringResult?.absenceFlag ===
          "1"
          ? true
          : false
      );
    }

    this.state = {
      allocationFixed: this.props.useCase !== "4" ? false : true,
      documentDrawerVisible: false,
      applyDocuments: [],
      submitbutton: "",
      afChecked: false,
      afMap: afMap,
    };
  }
  async componentDidMount() {}

  onShowQestion = (e) => {
    document.getElementById("question_div")!.style.display = "";
    document.getElementById("op_question_div")!.style.display = "none";
    document.getElementById("cl_question_div")!.style.display = "";
  };

  onHideQuestion = (e) => {
    document.getElementById("question_div")!.style.display = "none";
    document.getElementById("op_question_div")!.style.display = "";
    document.getElementById("cl_question_div")!.style.display = "none";
  };

  onShowStudentDetail = (e) => {
    document.getElementById("dl_student_info")!.style.display = "";
    document.getElementById("op_student_info")!.style.display = "none";
    document.getElementById("cl_student_info")!.style.display = "";
  };

  onHideStudentDetail = (e) => {
    document.getElementById("dl_student_info")!.style.display = "none";
    document.getElementById("op_student_info")!.style.display = "";
    document.getElementById("cl_student_info")!.style.display = "none";
  };

  onDocumentLinkClick = (appliDocuments?: ApplyDocumentViewItem[]) => {
    this.setState({
      applyDocuments: appliDocuments,
      documentDrawerVisible: true,
    });
  };
  onDocumentDrawerClose = () => {
    this.setState({
      applyDocuments: undefined,
      documentDrawerVisible: false,
    });
  };
  // showSuccessMessage = (msg: string) => {
  //   message.success(msg);
  // };

  // backToBeforePage = () => {
  //   const { navigation } = this.props;
  //   if (this.props.useCase === "1") {
  //     navigation!(`/ScoringList`);
  //   } else if (this.props.useCase === "2") {
  //     navigation!(`/ScoringResultList`);
  //   } else if (this.props.useCase === "3") {
  //     navigation!(`/ScoringResultList`);
  //   } else {
  //     this.props.backToBeforePage();
  //   }
  // };

  onFinish = async () => {
    // console.log("Success:", Object.keys(values));
    let values;
    try {
      // if (this.props.useCase === "1" && this.state.afChecked) {
      //   values = await this._form.current.getFieldsValue(true);
      // } else {
      // values = await this._form.current.validateFields();
      // }
      if (this.props.useCase === "1" && this.state.submitbutton === "save") {
        values = await this._form.current.getFieldsValue(true);
      } else {
        values = await this._form.current.validateFields();
      }
      // console.log("Success:", values);
    } catch (errorInfo) {
      console.log("Failed:", errorInfo);
      return;
    }

    const items: SaveScoringDataItem[] = [];
    Object.keys(values).forEach((key, keyIndex) => {
      const value: string = values[key] ? String(values[key]) : "";
      items.push({ key: key, value: value });
    });
    let scoringStatus = "";
    let api = "";
    if (this.props.useCase === "1") {
      scoringStatus = this.state.submitbutton === "complete" ? "2" : "1";
      api = "/Scoring/savedata";
    } else if (this.props.useCase === "2") {
      scoringStatus = "4";
      api = "/Scoring/saveconfirmdata";
    } else if (this.props.useCase === "3") {
      scoringStatus = "3";
      api = "/Scoring/saveupdatedata";
    }
    try {
      this._page.current?.setState({ isPageLoading: true });
      const saveData: SaveScoringDataRequestBean = {
        examinationSubjectId: this.props.scoringData.examinationSubjectId,
        useCase: this.props.useCase,
        scoringPatternType: this.props.scoringData.scoringPatternType,
        interviewElapsedTime: 0,
        scoringStatus: scoringStatus,
        values: items,
      };
      const result = await http<
        SaveScoringResultResponseBean,
        SaveScoringDataRequestBean
      >({
        path: api,
        method: "post",
        body: saveData,
        accessToken: this.context.accessToken,
      });
      if (result.ok && result.body) {
        message.success(Messages["MSG-004"]);
        this._page.current?.setState({ isPageLoading: false });
        if (this.state.submitbutton === "complete") {
          this.props.backToBeforePage();
        }
      } else {
        this._page.current?.setState({ isPageLoading: false });
        let errorContent = result.body?.error;
        if (isNullOrSpace(errorContent)) {
          errorContent = Messages["ERR-047"];
        }
        message.error(errorContent);
      }
    } catch (error) {
      console.log(error);
      message.error(Messages["ERR-047"]);
      this._page.current?.setState({ isPageLoading: false });
    }
  };
  setFormFieldValue = (name: string, value: any) => {
    // console.log(name, value);
    this._form.current.setFieldsValue({ [name]: value });
  };
  getFormFieldValue = (name: string): any => {
    return this._form.current.getFieldValue(name);
  };
  onCompleteButtonClick = (e) => {
    confirm({
      title: Messages["CON-008"],
      icon: <ExclamationCircleOutlined />,
      content: Messages["CON-009"],
      onOk: () => {
        this.setState({ submitbutton: "complete" }, () => {
          this.onFinish();
        });
        // this._form.current.submit();
      },
      onCancel: () => {
        this.setState({ submitbutton: "" });
      },
    });
  };
  onUpdateCompleteButtonClick = (e) => {
    confirm({
      title: Messages["CON-010"],
      icon: <ExclamationCircleOutlined />,
      onOk: () => {
        this.setState({ submitbutton: "complete" }, () => {
          this.onFinish();
        });
        // this._form.current.submit();
      },
      onCancel: () => {
        this.setState({ submitbutton: "" });
      },
    });
  };
  onConfirmCompleteButtonClick = (e) => {
    confirm({
      title: Messages["CON-011"],
      icon: <ExclamationCircleOutlined />,
      content: Messages["CON-012"],
      onOk: () => {
        this.setState({ submitbutton: "complete" }, () => {
          this.onFinish();
        });
        // this._form.current.submit();
      },
      onCancel: () => {
        this.setState({ submitbutton: "" });
      },
    });
  };
  onSaveButtonClick = (e) => {
    this.setState({ submitbutton: "save" }, () => {
      this.onFinish();
    });
    // this._form.current.submit();
  };
  onBeginButtonClick = async (e) => {
    let api = "";
    if (this.props.useCase === "1") {
      api = "/Scoring/start";
    } else if (this.props.useCase === "2") {
      api = "/Scoring/startconfirm";
    } else if (this.props.useCase === "3") {
      api = "/Scoring/startupdate";
    }
    try {
      this._page.current?.setState({ isPageLoading: true });
      const result = await http<StartScoringResponseBean, any>({
        path: api,
        method: "post",
        accessToken: this.context.accessToken,
        body: {
          examSubjectId: this.props.scoringData.examinationSubjectId,
          objectId: this.props.objectId,
        },
      });
      if (result.ok && result.body) {
        this._page.current?.setState({ isPageLoading: false });
        this.setState({ allocationFixed: true });
        this.props.setShowDialog(true);
      } else {
        this._page.current?.setState({ isPageLoading: false });
        let errorContent = result.body?.error;
        if (isNullOrSpace(errorContent)) {
          errorContent = Messages["ERR-020"];
        }
        modal.error({
          title: Messages["ERR-049"],
          content: errorContent,
        });
      }
    } catch (error) {
      // errorService.log(error);
      this._page.current?.setState({ isPageLoading: false });
    }
  };
  onAfCheckboxChange = (e: { target: { checked: boolean } }) => {
    this.setState({ afChecked: e.target.checked });
    if (this.props.useCase === "1") {
      const afMap = new Map();
      afMap.set(
        this.props.scoringData.applicants[0].applicantId,
        e.target.checked
      );
      this.setState({
        afMap: afMap,
      });
    }
  };
  setButtonRow = () => {
    if (this.props.useCase === "1") {
      return (
        <Row className="button-row" align="middle">
          <Col span={6}>
            <Button
              type="link"
              onClick={(e) =>
                this.props.backToBeforePage(this.state.allocationFixed)
              }
              style={{
                fontSize: "15px",
              }}
            >
              担当受験生一覧に戻る
            </Button>
          </Col>
          <Col span={18}>
            <div style={{ float: "right" }}>
              <Space
                style={{
                  display: this.state.allocationFixed ? "" : "none",
                }}
              >
                <Button
                  type="primary"
                  danger={true}
                  size="middle"
                  onClick={(e) => this.onCompleteButtonClick(e)}
                >
                  完了
                </Button>
                <Button
                  type="primary"
                  size="middle"
                  onClick={(e) => this.onSaveButtonClick(e)}
                >
                  一時保存
                </Button>
              </Space>
              <Space
                style={{
                  display: this.state.allocationFixed ? "none" : "",
                }}
              >
                <Popconfirm
                  title={Messages["CON-013"]}
                  onConfirm={(e) => {
                    this.onBeginButtonClick(e);
                  }}
                  okText="OK"
                  cancelText="キャンセル"
                >
                  <Button type="primary" size="middle">
                    {!this.props.scoringData.applicants[0].userScoringResult ||
                    this.props.scoringData.applicants[0].userScoringResult
                      ?.scoringStatus === null ||
                    this.props.scoringData.applicants[0].userScoringResult
                      ?.scoringStatus === "0"
                      ? "採点開始"
                      : "採点修正"}
                  </Button>
                </Popconfirm>
              </Space>
            </div>
          </Col>
        </Row>
      );
    } else if (this.props.useCase === "2") {
      return (
        <Row className="button-row" align="middle">
          <Col span={6}>
            <Button
              type="link"
              onClick={(e) =>
                this.props.backToBeforePage(this.state.allocationFixed)
              }
              style={{
                fontSize: "15px",
              }}
            >
              採点結果一覧に戻る
            </Button>
          </Col>
          <Col span={18}>
            <div style={{ float: "right" }}>
              <Space
                style={{
                  display: this.state.allocationFixed ? "" : "none",
                }}
              >
                <Button
                  type="primary"
                  danger={true}
                  size="middle"
                  onClick={(e) => this.onConfirmCompleteButtonClick(e)}
                >
                  採点確定
                </Button>
              </Space>
              <Space
                style={{
                  display: this.state.allocationFixed ? "none" : "",
                }}
              >
                <Popconfirm
                  title={Messages["CON-013"]}
                  onConfirm={(e) => {
                    this.onBeginButtonClick(e);
                  }}
                  okText="OK"
                  cancelText="キャンセル"
                >
                  <Button type="primary" size="middle">
                    採点確定値入力
                  </Button>
                </Popconfirm>
              </Space>
            </div>
          </Col>
        </Row>
      );
    } else if (this.props.useCase === "3") {
      return (
        <Row className="button-row" align="middle">
          <Col span={6}>
            <Button
              type="link"
              onClick={(e) =>
                this.props.backToBeforePage(this.state.allocationFixed)
              }
              style={{
                fontSize: "15px",
              }}
            >
              採点結果一覧に戻る
            </Button>
          </Col>
          <Col span={18}>
            <div style={{ float: "right" }}>
              <Space
                style={{
                  display: this.state.allocationFixed ? "" : "none",
                }}
              >
                <Button
                  type="primary"
                  danger={true}
                  size="middle"
                  onClick={(e) => this.onUpdateCompleteButtonClick(e)}
                >
                  保存
                </Button>
              </Space>
              <Space
                style={{
                  display: this.state.allocationFixed ? "none" : "",
                }}
              >
                <Popconfirm
                  title={Messages["CON-014"]}
                  onConfirm={(e) => {
                    this.onBeginButtonClick(e);
                  }}
                  okText="OK"
                  cancelText="キャンセル"
                >
                  <Button type="primary" size="middle">
                    採点修正開始
                  </Button>
                </Popconfirm>
              </Space>
            </div>
          </Col>
        </Row>
      );
    } else if (this.props.useCase === "4") {
      return (
        <Row className="button-row" align="middle">
          <Col span={6}>
            <Button
              type="link"
              onClick={(e) => this.props.backToBeforePage()}
              style={{
                fontSize: "15px",
              }}
            >
              志願者一覧に戻る
            </Button>
          </Col>
        </Row>
      );
    }
  };

  render(): React.ReactNode {
    const buttonRow = this.setButtonRow();
    return (
      <Page ref={this._page} title="採点">
        <div className="data_content">
          <Form ref={this._form} onFinish={this.onFinish}>
            {buttonRow}
            <div className="contentArea col2">
              <div className="leftArea">
                <Space direction="vertical" style={{ width: "100%" }}>
                  {this.props.scoringData.questionContents &&
                  this.props.scoringData.questionContents.length > 0 ? (
                    <div>
                      <h4>問題</h4>
                      <div
                        id="question_div"
                        style={{
                          whiteSpace: "pre-wrap",
                          textAlign: "left",
                        }}
                      >
                        {this.props.scoringData.questionContents}
                      </div>
                      <span
                        id={`op_question_div`}
                        className="aiScore"
                        onClick={(e) => this.onShowQestion(e)}
                        style={{ display: "none", marginTop: "5px" }}
                      >
                        <FolderOutlined />
                        詳細を見る
                      </span>
                      <span
                        id={`cl_question_div`}
                        className="aiScore"
                        onClick={(e) => this.onHideQuestion(e)}
                        style={{ marginTop: "5px" }}
                      >
                        <FolderOpenOutlined />
                        詳細を閉じる
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                  <div>
                    <h4>解答</h4>
                    <ApplyDocumentTabs
                      documents={this.props.scoringData.applicants[0].documents}
                      isScoringPage={true}
                    />
                  </div>
                </Space>
              </div>
              <div className="rightArea">
                <Space direction="vertical" style={{ width: "100%" }}>
                  <div className="test_info">
                    <div className="student_info">
                      <div className="scoring_multicolumn">
                        <Button
                          type="primary"
                          onClick={() => {
                            this.onDocumentLinkClick(
                              this.props.scoringData.applicants[0]
                                .commonDocuments
                            );
                          }}
                          style={{ marginBottom: "5px" }}
                        >
                          提出書類情報
                        </Button>
                        {this.props.useCase === "1" &&
                        this.state.allocationFixed ? (
                          <Form.Item
                            label=""
                            name={`af_${this.props.scoringData.applicants[0].applicantId}`}
                            initialValue={
                              this.props.scoringData.applicants[0]
                                .userScoringResult?.absenceFlag === "1"
                                ? true
                                : false
                            }
                            valuePropName="checked"
                          >
                            <Checkbox
                              style={{ fontSize: "14px", color: "#3fb0ac" }}
                              onChange={this.onAfCheckboxChange}
                              checked={this.state.afChecked}
                            >
                              欠席
                            </Checkbox>
                          </Form.Item>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div style={{ fontWeight: "bold" }}>
                      {this.props.scoringData.judgementUnitName}{" "}
                      {this.props.scoringData.subjectName}
                    </div>
                    {this.props.scoringData.notes &&
                    this.props.scoringData.notes != null ? (
                      <div
                        style={{
                          color: "red",
                          whiteSpace: "pre-wrap",
                          fontSize: "13px",
                          marginTop: "5px",
                          marginBottom: "5px",
                        }}
                      >
                        {this.props.scoringData.notes}
                      </div>
                    ) : (
                      ""
                    )}
                    <dl
                      id={`dl_student_info`}
                      style={{ display: "none", marginTop: "5px" }}
                    >
                      {this.props.scoringData.dispFlag_ExamNumber === "1" ? (
                        <>
                          <dt>受験番号</dt>
                          <dd>{this.props.scoringData.applicants[0].examNo}</dd>
                        </>
                      ) : (
                        ""
                      )}
                      {this.props.scoringData.dispFlag_Name === "1" ? (
                        <>
                          <dt>氏名</dt>
                          <dd>
                            {this.props.scoringData.applicants[0].sei}{" "}
                            {this.props.scoringData.applicants[0].mei}
                          </dd>
                        </>
                      ) : (
                        ""
                      )}
                      {this.props.scoringData.dispFlag_NameKana === "1" ? (
                        <>
                          <dt>氏名カナ</dt>
                          <dd>
                            {this.props.scoringData.applicants[0].seiKana}{" "}
                            {this.props.scoringData.applicants[0].meiKana}
                          </dd>
                        </>
                      ) : (
                        ""
                      )}
                      {this.props.scoringData.dispFlag_Birthday === "1" ? (
                        <>
                          <dt>生年月日</dt>
                          <dd>
                            {moment(
                              this.props.scoringData.applicants[0].birthday
                            ).format("yyyy/MM/DD")}
                          </dd>
                        </>
                      ) : (
                        ""
                      )}
                      {this.props.scoringData.dispFlag_HighSchool === "1" ? (
                        <>
                          <dt>学校名</dt>
                          <dd>
                            {
                              this.props.scoringData.applicants[0]
                                .highSchoolName
                            }
                          </dd>
                        </>
                      ) : (
                        ""
                      )}
                    </dl>
                    <span
                      id={`op_student_info`}
                      className="aiScore"
                      onClick={(e) => this.onShowStudentDetail(e)}
                      style={{ marginBottom: "1em" }}
                    >
                      <FolderOutlined />
                      受験者情報を見る
                    </span>
                    <span
                      id={`cl_student_info`}
                      className="aiScore"
                      onClick={(e) => this.onHideStudentDetail(e)}
                      style={{ display: "none", marginBottom: "1em" }}
                    >
                      <FolderOpenOutlined />
                      受験者情報を閉じる
                    </span>
                  </div>

                  <Spin
                    indicator={<></>}
                    spinning={!this.state.allocationFixed}
                  >
                    <ScoringTable
                      showPersonInfo={true}
                      showPersonInfoItemFlags={[
                        this.props.scoringData.dispFlag_ExamNumber,
                        this.props.scoringData.dispFlag_Name,
                        this.props.scoringData.dispFlag_NameKana,
                        this.props.scoringData.dispFlag_Birthday,
                        this.props.scoringData.dispFlag_HighSchool,
                      ]}
                      pattern={this.props.scoringData.scoringPatternType}
                      useCase={this.props.useCase}
                      scoringType={this.props.scoringType}
                      evaluations={this.props.scoringData.evaluationViewPoints}
                      applicants={[this.props.scoringData.applicants[0]]}
                      onDocumentLinkClick={this.onDocumentLinkClick}
                      setFormFiledValue={this.setFormFieldValue}
                      getFormFiledValue={this.getFormFieldValue}
                      afMap={this.state.afMap}
                    />
                    <br />
                  </Spin>
                </Space>
              </div>
            </div>
          </Form>
        </div>
        <ApplyDocumentDrawer
          documents={this.state.applyDocuments}
          onClose={this.onDocumentDrawerClose}
          visible={this.state.documentDrawerVisible}
        />
      </Page>
    );
  }
}

export default withRouterDom(ScoringWrittenPage);
